import { useRef, useState } from 'react';
import { useGetConnectedDevicesQuery } from 'services/devices/devices.api';
import CameraGrid from './components/CameraGrid';
import CameraSelectModal from './components/CameraSelectModal';
import CameraViewControls from './components/CameraViewControls';
import { VMS_VIEW_MODES } from './config/vms.config';
import useCameraSelection from './hooks/useCameraSelection';
import styles from './assets/ExacqVision.module.css';

/** Camera selection and viewing shared by the page and dashboard widget. */
export default function VMSView({ compact = false, widgetRuntime }) {
  const {
    data: connectedDevices = [],
    isLoading,
    isError,
    refetch,
  } = useGetConnectedDevicesQuery();
  const { selectedCameraIds, selectCamera, clearCamera, clearAllCameras } = useCameraSelection();
  const [viewMode, setViewMode] = useState(VMS_VIEW_MODES[0]);
  const [selectedPanelIndex, setSelectedPanelIndex] = useState(null);
  const cameraControlRef = useRef(null);

  const openCameraSelection = (panelIndex, cameraControl) => {
    cameraControlRef.current = cameraControl;
    setSelectedPanelIndex(panelIndex);
  };

  return (
    <div className={`${styles.root}${compact ? '' : ' mt-3'}`}>
      <CameraViewControls viewMode={viewMode} onChange={setViewMode} />
      <CameraGrid
        compact={compact}
        viewMode={viewMode}
        selectedCameraIds={selectedCameraIds}
        onSelectCamera={openCameraSelection}
        onClearCamera={clearCamera}
        onClearAllCameras={clearAllCameras}
        widgetRuntime={widgetRuntime}
      />
      <CameraSelectModal
        open={selectedPanelIndex !== null}
        selectedPanelIndex={selectedPanelIndex}
        selectedCameraIds={selectedCameraIds}
        cameras={connectedDevices}
        isLoading={isLoading}
        isError={isError}
        onRetry={refetch}
        onClose={() => setSelectedPanelIndex(null)}
        onSelect={(cameraId) => {
          selectCamera(selectedPanelIndex, cameraId);
          setSelectedPanelIndex(null);
        }}
        onExited={() => cameraControlRef.current?.focus()}
        widgetRuntime={widgetRuntime}
      />
    </div>
  );
}
